/*
 * CC Jewelers - variant guard
 * 1. Greys out (disables) choices Stuller does not offer, based on the full variant list printed by
 *    snippets/product-variant-picker.liquid:  Metal is always selectable, a Size is selectable only if it is
 *    offered in the selected Metal, a Diamond grade only if it is offered in the selected Metal + Size.
 * 2. If a change would land on a combination that does not exist (for example switching to a metal that is not
 *    made in the current size), the other choices move to the closest combination that does exist, so the
 *    page always shows a real, purchasable variant (never "Unavailable").
 * 3. When the selected variant has no photo of its own, still refreshes the gallery and shows the first photo
 *    that the theme chose for it (the stock theme returned early and left the previous variant's photo on screen).
 */
(function () {
  if (window.__ccVariantGuard) return;
  window.__ccVariantGuard = true;

  var SUFFIX = ' (not available)';

  // Liquid prints at most 250 variants, so a product with more (the round stud earrings have 337) is completed
  // from /products/<handle>.js. Until the full list is known nothing is disabled or repaired.
  var cache = {};
  function handleOf() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function parse(vs) {
    var el = vs.querySelector('script[data-cc-variants]');
    if (!el) return null;
    var d;
    try { d = JSON.parse(el.textContent); } catch (e) { return null; }
    var list = d.v || [];
    if (!d.n || list.length >= d.n) return list;
    var h = handleOf();
    if (!h) return null;
    if (cache[h] && cache[h].list) return cache[h].list;
    if (!cache[h]) {
      cache[h] = { list: null };
      fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) {
        cache[h].list = p.variants.map(function (v) { return { id: v.id, o: v.options, a: v.available, s: v.sku }; });
        queue();
      }).catch(function () { cache[h] = null; });
    }
    return null;
  }

  function groups(vs) {
    return Array.prototype.slice.call(vs.querySelectorAll('[data-cc-option]')).map(function (g) {
      var sel = g.querySelector('select');
      return {
        idx: parseInt(g.getAttribute('data-cc-option'), 10),
        el: g,
        select: sel,
        radios: sel ? [] : Array.prototype.slice.call(g.querySelectorAll('input[type="radio"]')),
        name: ((g.querySelector('legend, label') || {}).textContent || '').replace(':', '').trim().toLowerCase()
      };
    });
  }

  function current(g) {
    if (g.select) return g.select.value;
    var c = g.radios.filter(function (r) { return r.checked; })[0];
    return c ? c.value : '';
  }

  function setValue(g, v) {
    if (g.select) {
      Array.prototype.forEach.call(g.select.options, function (o) {
        if (o.value === v) { o.setAttribute('selected', 'selected'); } else { o.removeAttribute('selected'); }
      });
      g.select.value = v;
    } else {
      g.radios.forEach(function (r) { r.checked = (r.value === v); });
      var out = g.el.querySelector('[data-selected-value]');
      if (out) out.textContent = v;
    }
  }

  // lower number = more important (kept when something has to give)
  function rank(g) {
    if (/metal/.test(g.name)) return 0;
    if (/size/.test(g.name)) return 1;
    if (/grade/.test(g.name)) return 2;
    return 3 + g.idx;
  }

  function matches(variant, sel, upToRank, gs, skipIdx) {
    for (var i = 0; i < gs.length; i++) {
      var g = gs[i];
      if (g.idx === skipIdx) continue;
      if (rank(g) < upToRank && variant.o[g.idx] !== sel[g.idx]) return false;
    }
    return true;
  }

  function sync(vs) {
    var variants = parse(vs);
    if (!variants) return;
    var gs = groups(vs);
    if (!gs.length) return;
    var sel = {};
    gs.forEach(function (g) { sel[g.idx] = current(g); });
    gs.forEach(function (g) {
      var r = rank(g);
      var ok = {};
      variants.forEach(function (v) {
        if (matches(v, sel, r, gs, g.idx)) ok[v.o[g.idx]] = true;
      });
      if (g.select) {
        Array.prototype.forEach.call(g.select.options, function (o) {
          var base = o.getAttribute('data-cc-base');
          if (base === null) { base = o.textContent; o.setAttribute('data-cc-base', base); }
          var enabled = !!ok[o.value];
          if (o.disabled !== !enabled) o.disabled = !enabled;
          var text = enabled ? base : base + SUFFIX;
          if (o.textContent !== text) o.textContent = text;
        });
      } else {
        g.radios.forEach(function (rd) {
          var enabled = !!ok[rd.value];
          rd.setAttribute('data-cc-offered', enabled ? 'true' : 'false');
        });
      }
    });
  }

  function exists(variants, sel, gs) {
    return variants.some(function (v) {
      return gs.every(function (g) { return v.o[g.idx] === sel[g.idx]; });
    });
  }

  function orderIndex(g, v) {
    var list = g.select ? Array.prototype.map.call(g.select.options, function (o) { return o.value; })
      : g.radios.map(function (r) { return r.value; });
    return list.indexOf(v);
  }

  function repair(vs, changedIdx) {
    var variants = parse(vs);
    if (!variants) return;
    var gs = groups(vs);
    var sel = {};
    gs.forEach(function (g) { sel[g.idx] = current(g); });
    if (exists(variants, sel, gs)) return;
    var changed = gs.filter(function (g) { return g.idx === changedIdx; })[0];
    var pool = variants.filter(function (v) { return !changed || v.o[changedIdx] === sel[changedIdx]; });
    if (!pool.length) return;
    var others = gs.filter(function (g) { return g.idx !== changedIdx; }).sort(function (a, b) { return rank(a) - rank(b); });
    var best = null, bestScore = null;
    pool.forEach(function (v) {
      var score = [v.a ? 0 : 1];
      others.forEach(function (g) {
        if (v.o[g.idx] === sel[g.idx]) { score.push(0, 0); return; }
        // not the same: closer in list order is better (sizes sorted small to large)
        score.push(1, Math.abs(orderIndex(g, v.o[g.idx]) - orderIndex(g, sel[g.idx])));
      });
      // compare lexicographically, but the availability flag first and then by importance
      if (!bestScore || cmp(score, bestScore) < 0) { best = v; bestScore = score; }
    });
    if (!best) return;
    gs.forEach(function (g) { if (g.idx !== changedIdx) setValue(g, best.o[g.idx]); });
  }

  function cmp(a, b) {
    for (var i = 0; i < a.length; i++) { if (a[i] !== b[i]) return a[i] - b[i]; }
    return 0;
  }

  // Runs before the theme's own change handler, so the theme reads an already-valid selection.
  document.addEventListener('change', function (event) {
    var vs = event.target && event.target.closest && event.target.closest('variant-selects');
    if (!vs) return;
    var holder = event.target.closest('[data-cc-option]');
    if (!holder) return;
    repair(vs, parseInt(holder.getAttribute('data-cc-option'), 10));
    sync(vs);
  }, true);

  var queued = false;
  function syncAll() {
    queued = false;
    Array.prototype.forEach.call(document.querySelectorAll('variant-selects'), sync);
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(syncAll); } }
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') queue(); else document.addEventListener('DOMContentLoaded', queue);

  // Gallery: keep the gallery in step with the selection even when the variant has no photo of its own.
  if (window.customElements) {
    customElements.whenDefined('product-info').then(function () {
      var PI = customElements.get('product-info');
      if (!PI || PI.prototype.__ccPatched) return;
      var orig = PI.prototype.updateMedia;
      PI.prototype.updateMedia = function (html, featuredId) {
        if (featuredId) return orig.call(this, html, featuredId);
        var first = html.querySelector('media-gallery ul li[data-media-id]');
        if (!first) return;
        var prefix = this.dataset.section + '-';
        var id = first.dataset.mediaId;
        if (id.indexOf(prefix) === 0) id = id.slice(prefix.length);
        return orig.call(this, html, id);
      };
      PI.prototype.updateMedia.__cc = true;
      PI.prototype.__ccPatched = true;
    });
  }
})();
